/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';
import { dispatchDisputeDetails } from '../../AssignDisputesDetail/store/actions';

export const setSelectedRebateProgram = (val) => {
  return {
    type: ActionTypes.SELECTED_REBATE_PROGRAM,
    payload: val,
  };
};

export const updateFirstLoad = () => {
  return { type: ActionTypes.FIRST_LOAD, payload: true };
};

// To Get disputes deatils based on plantype and program
export const getAssignDisputeDetail = (values, programList) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ASSIGN_DISPUTE_DETAIL}`, values)
    .then((response) => {
      dispatch({ type: 'ASSIGN_ALL_TO_DEFAULT', payload: null });
      dispatch(
        dispatchDisputeDetails({
          data: response.data?.data,
          programList: programList,
          selected: values,
        })
      );
      return dispatch({
        type: ActionTypes.ASSIGN_DISPUTE_DETAIL,
        payload: response.data,
      });
    })
    .catch((response) => {
      dispatch({
        type: ActionTypes.ASSIGN_DISPUTE_DETAIL,
        payload: response.data,
      });
    });
};
// To Get programs based on plantype
export const getRebateProgram = (planType) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: planType })
    .then((response) => {
      let list = [];
      const dropdown = response.data;
      if (dropdown?.status === '001' && dropdown?.message === 'SUCESS') {
        if (!_.isEmpty(dropdown?.data)) {
          list = _.map(dropdown?.data, (val, ind) => {
            return {
              ...val,
              id: val.rebateProgramCd,
              name: val.rebateProgramCd + ' | ' + val.shortDescr,
            };
          });
        }
      }
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      );
      list.unshift({ id: 'All', name: 'All | All Rebate Program' });
      // return dispatch({
      //   type: ActionTypes.REBATE_PROGRAM_LIST,
      //   payload: list,
      // });
      return list;
    })
    .catch((response) => {
      return dispatch({
        type: ActionTypes.REBATE_PROGRAM_LIST,
        payload: [],
      });
    });
};
// To get manufacturer list based on plantype and rebate program
export const storeManufacturesList = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_MATCHED_MANUFACTURER_DETAILS}`, val)
    .then((response) => {
      return dispatch({
        type: ActionTypes.MANUFACTURER_LIST,
        payload: response.data?.data,
      });
    })
    .catch((response) =>
      dispatch({ type: ActionTypes.MANUFACTURER_LIST, payload: [] })
    );
};

export const storeErrorList = (val) => {
  return { type: ActionTypes.ERROR_LIST, payload: val };
};

export const resetStore = (val) => {
  return { type: ActionTypes.RESET_STATE };
};
// To get plantype available
export const getPlanType = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS}`, values)
    .then((response) => {
      return dispatch({
        type: ActionTypes.GET_PLAN_TYPE,
        payload: response.data,
      });
    })
    .catch((response) => {
      dispatch(storeErrorList([Constants.ERR_PROCESSING_REQ]));
      return response;
    });
};
